import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const TOKEN = 'symdb-token';
const LOGIN = 'symdb-login';

export default new Vuex.Store({
  state: {
    appName: 'SymDB',
    token: localStorage.getItem(TOKEN) || '',
    login: localStorage.getItem(LOGIN) || '',
    isThereNews: false,
    tree: [],
    admin: false,
    news: [],
    publicSets: [],
    userSets: [],
  },

  mutations: {
    set_publicSets(state, publicSets) {
      state.publicSets = publicSets;
    },
    set_userSets(state, userSets) {
      state.userSets = userSets;
    },
    set_news(state, news) {
      state.news = news;
    },
    set_isThereNews(state, bool) {
      state.isThereNews = bool;
    },
    set_app_name(name) {
      this.state.appName = name;
    },
    auth_request(state) {
      state.status = 'loading';
      state.login = '';
    },
    auth_success(state, token) {
      state.status = 'success';
      state.token = token;
    },
    set_login(state, login) {
      state.login = login;
    },
    set_admin(state, admin) {
      state.admin = admin;
    },
    auth_error(state) {
      state.status = 'error';
      state.token = '';
      state.login = '';
      state.admin = false;
    },
    logout(state) {
      state.status = '';
      state.token = '';
      state.login = '';
      state.admin = false;
    },
    set_tree(state, tree) {
      state.tree = tree;
    },
  },
  actions: {
    getSelections({ commit }, user) {
      const token = localStorage.getItem(TOKEN);
      user.token = token !== undefined ? token : '';

      return new Promise((resolve, reject) => {
        Vue.http.post('api/getSelections', user).then(
          resp => {
            const data = resp.body;

            const success = data.success;

            if (success === true) {
              commit('set_publicSets', [
                { id: 0, selection: 'No selection' },
                ...data.public_selections,
              ]);
              commit('set_userSets', [
                { id: 0, selection: 'No selection' },
                ...data.user_selections,
              ]);
            }
            resolve(resp);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    login({ commit }, user) {
      const token = localStorage.getItem(TOKEN);
      user.token = token !== undefined ? token : '';

      const myStore = this;

      return new Promise((resolve, reject) => {
        commit('auth_request');

        Vue.http.post('api/connexion', user).then(
          resp => {
            const data = resp.body;

            if (data != null) {
              const success = data.success;

              if (success != null) {
                if (success === true) {
                  localStorage.setItem(TOKEN, data.token);
                  localStorage.setItem(LOGIN, data.login);

                  Vue.http.headers.common.Authorization = token;

                  myStore.dispatch('load_tree', user).then(
                    () => {
                      commit('auth_success', data.token);
                      commit('set_login', data.login);
                      commit('set_admin', data.admin);
                      commit('set_news', data.news);

                      commit('set_publicSets', [
                        { id: null, selection: 'Select a public set' },
                        ...data.public_selections,
                      ]);
                      commit('set_userSets', [
                        { id: null, selection: 'Select a user-defined set' },
                        ...data.user_selections,
                      ]);

                      commit('set_isThereNews', data.news.length > 0);
                      resolve(resp);
                    },
                    () => {
                      reject(resp);
                    }
                  );
                } else {
                  resolve(resp);
                  commit('logout');
                }
              } else {
                reject(resp);
                commit('logout');
              }
            } else {
              reject(resp);
              commit('logout');
            }
          },
          error => {
            commit('auth_error');
            commit('logout');
            localStorage.removeItem(TOKEN);
            localStorage.removeItem(LOGIN);
            reject(error);
          }
        );
      });
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit('logout');
        localStorage.removeItem(TOKEN);
        localStorage.removeItem(LOGIN);
        delete Vue.http.headers.common.Authorization;
        resolve();
      });
    },

    load_tree({ commit }) {
      return new Promise((resolve, reject) => {
        const user = {
          login: '',
          token: '',
        };

        if (localStorage.getItem(TOKEN) != null && localStorage.getItem(LOGIN) != null) {
          user.login = localStorage.getItem(LOGIN);
          user.token = localStorage.getItem(TOKEN);
        }

        Vue.http.post('api/get_tree', user).then(
          resp => {
            commit('set_tree', resp.data);
            resolve(resp);
          },
          resp => {
            reject(resp);
          }
        );
      });
    },

    forgotPassword({ commit }, email) {
      return new Promise((resolve, reject) => {
        Vue.http.post('api/forgotPassword', { email: email }).then(
          resp => {
            const data = resp.body;

            if (data != null) {
              const success = data.success;

              if (success != null && success === true) {
                resolve(resp);
              } else {
                reject(resp);
              }
            } else {
              reject(resp);
            }
          },
          resp => {
            reject(resp);
          }
        );
      });
    },
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    getToken: state => state.token,
    getLogin: state => state.login,
    getTreeData: state => state.tree,
    isAdmin: state => state.admin,
    getNews: state => state.news,
    getPublicSets: state => state.publicSets,
  },
});
